import BaggageSelection from "./components/BaggageSelection/BaggageSelection";
import MealSelection from "./components/MealSelection/MealSelection";
import PlaneSeating from "./components/PlaneSeating/PlaneSeating";
import { useSSRContext } from "./context/SSRContext";


export default function SSROutlet() {
  const { cursor } = useSSRContext();
  if (cursor.ssrType === "seats") return <PlaneSeating />;
  if (cursor.ssrType === "baggages") return <BaggageSelection/>;
  if (cursor.ssrType === "meals") return <MealSelection/>;
  return null;
}
